<template>
    
  <EstrattiConto />

</template>

<script>
import EstrattiConto from '../components/pratiche/estratticonto/EstrattiConto.vue'

export default {
  pageName: 'fatture',
  components: {
    EstrattiConto

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
